// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"Text_textContainer__hrdxS","title":"Text_title__1GvvU"};